import { render, staticRenderFns } from "./AddContract.vue?vue&type=template&id=80e59b24&"
import script from "./AddContract.vue?vue&type=script&lang=js&"
export * from "./AddContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports